import t9n from "@bimproject/t9n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import ParameterCard from "./ParameterCard";
import { useFinder } from "../../../../../../modules/finder";
import { useParameters } from "../../../../../../modules/shared-entities";

export default function ParameterFinderPlugin(props) {
    const { Component = ParameterCard, disabledParameters = [], onSelect } = props;

    const parameters = useParameters().data?.parameters ?? [];

    const { i18n } = useTranslation();

    const { token } = useFinder();

    const filteredParameters = useMemo(
        () => parameters
            .filter(
                (parameter) => !parameter.deprecated
            )
            .map(
                (parameter) => (
                    {
                        disabled: disabledParameters.includes(parameter.id),
                        id: parameter.id,
                        name: t9n(parameter.name, i18n.language),
                        type: parameter.dataType,
                        units: parameter.units || [],
                    }
                )
            )
            .filter(
                (item) => item.name.toLowerCase().includes(token.toLowerCase()) || item.id === token
            )
            .sort(
                (a, b) => a.name.localeCompare(b.name)
            ),
        [parameters, disabledParameters, i18n.language, token],
    );

    return (
        <>
            {
                filteredParameters.map(
                    (parameter) => (
                        <li key={ parameter.id }>
                            <Component
                                { ...parameter }
                                onClick={ () => onSelect(parameter.id, parameter.units?.[0]) }
                            />
                        </li>
                    )
                )
            }
        </>
    );
}
